// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3SGUb","footer":"ModalError_footer__39xmE"};